module.exports = __webpack_public_path__ + "images/places/training_651-41b895b29f645d03ebc61f9be376d379.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_651.jpg
 ** module id = 319
 ** module chunks = 0
 **/